module.exports = __webpack_public_path__ + "static/img/Sara.9559a0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Sara.jpg
// module id = ghwY
// module chunks = 1